exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#454645",
	"menuActiveText": "#128CBC",
	"subMenuActiveText": "#128CBC",
	"menuBg": "#3C8DBC",
	"menuHover": "#3C8DBC",
	"subMenuBg": "#F5F5F3",
	"subMenuHover": "#E3E3EA",
	"sideBarWidth": "200px",
	"sidebarBg": "#F5F5F3"
};